import React from "react";
import { Box, Typography, ButtonBase } from "@mui/material";
import { PremiumCard, dashboardTokens } from "./dashboardStyles";

/**
 * Card de KPI executivo compacto: número grande, label pequena em
 * maiúsculas, uma sublinha opcional (breakdown) e um hint opcional
 * (variação/contexto). Clicável quando `onClick` é passado — inteiro card
 * vira um botão acessível, não só um pedaço dele.
 */
function DashboardKpiCard({ label, value, sublabel, hint, onClick, cinza }) {
  const content = (
    <Box sx={{ p: 2.25, textAlign: "left", width: "100%" }}>
      <Typography
        sx={{
          fontSize: "0.68rem",
          fontWeight: 700,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: dashboardTokens.textSecondary,
          mb: 0.75,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: "1.9rem",
          fontWeight: 700,
          color: cinza || "#1e1e1e",
          lineHeight: 1.1,
        }}
      >
        {value}
      </Typography>
      {sublabel && (
        <Typography sx={{ fontSize: "0.78rem", color: dashboardTokens.textSecondary, mt: 0.5 }}>
          {sublabel}
        </Typography>
      )}
      {hint && (
        <Typography sx={{ fontSize: "0.74rem", color: dashboardTokens.textSecondary, mt: 0.75 }}>
          {hint}
        </Typography>
      )}
    </Box>
  );

  return (
    <PremiumCard sx={{ height: "100%" }}>
      {onClick ? (
        <ButtonBase
          onClick={onClick}
          sx={{ width: "100%", height: "100%", display: "block", textAlign: "left", "&:hover": { backgroundColor: dashboardTokens.surfaceMuted } }}
        >
          {content}
        </ButtonBase>
      ) : (
        content
      )}
    </PremiumCard>
  );
}

export default DashboardKpiCard;
